/* Clearlight store mode commerce (ANZ, D-0956, 2026-10-08), and the EU and UK lead stores selling
   add-ons (D-0978, 2026-10-12). Loaded by snippets/cl-commerce.liquid when Theme settings > Commerce >
   cl_store_mode is "commerce" or Sell add-ons online is on; a lead store with it off never loads it.
   On a lead store the header cart icon carries data-cl-cart-hide-empty: it shows once the cart has
   something in it and goes again when the cart is emptied.

   - Header cart count: [data-cl-cart-count] / [data-cl-cart-link] follow every add and cart change,
     no reload; refreshed from /cart.js when the page comes back from the back-forward cache.
   - Product page add to cart: cl-product.js posts to /cart/add.js and dispatches cl:cart-added; this
     shows "Added" on the button, bumps the count and leaves a note for the cart
     page's confirmation. cl-product.js then goes to /cart (cart_type "page", as live ANZ).
   - Add-on rows ([data-cl-quick-add]): /cart/add.js without leaving the page, a toast with
     View cart / Check out, the count bumps.
   - Cart page ([data-cl-cart]): quantity steppers, typed quantities, remove, discount code and note
     through /cart/change.js and /cart/update.js with the section re-rendered in the same response
     (Section Rendering API). Cart attributes are never sent, so _ph_distinct_id / _ph_session_id
     (PostHog order stitching, cl-posthog.js) stay on the cart. Without script the form still works.
   - dataLayer: nothing. GTM-W5VCRQM's add_to_cart trigger (Google Ads 819028415 + Floodlight addto0)
     already fires on live from the Shopify Google & YouTube app, which pushes gtag('event',
     'add_to_cart' / 'view_cart' / 'begin_checkout' ...) into the page's dataLayer for every Ajax or form
     add, theme or no theme. A theme push of its own doubled both tags (measured 2026-10-08), so the
     theme leaves the dataLayer to the app. The cart icon carries icon-cart (Floodlight viewc0) and the
     cart button reads "Check out" (Floodlight check0), the two click triggers the container has.
     PostHog's Product Added / Cart Viewed / Checkout Started stay in cl-posthog.js. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('cl-commerce-config');
  if (!cfgEl || window.__clCommerce) return;
  window.__clCommerce = true;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var L = C.labels || {};
  var root = C.root || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  /* ------------------------------------------------------------------- count */
  function setCount(n, bump) {
    n = Number(n) || 0;
    C.itemCount = n;
    document.querySelectorAll('[data-cl-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = !n;
      if (bump) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
    });
    document.querySelectorAll('[data-cl-cart-link]').forEach(function (a) {
      a.setAttribute('aria-label', (a.getAttribute('data-cl-cart-label') || 'Cart') + ' (' + n + ')');
      if (a.hasAttribute('data-cl-cart-hide-empty')) a.hidden = !n;
    });
  }
  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function refreshCount(bump) {
    return getCart().then(function (c) { setCount(c.item_count, bump); return c; }).catch(function () { /* offline */ });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(false); });

  /* ------------------------------------------------- add (product page + rows) */
  document.addEventListener('cl:cart-added', function (e) {
    var d = e.detail || {};
    var it = d.item;
    if (!it) return;
    var qty = Number(d.quantity) || 0;
    if (!qty && d.form && d.form.querySelector) {
      var q = d.form.querySelector('[name="quantity"]');
      qty = q ? Number(q.value) || 1 : 1;
    }
    qty = qty || 1;
    setCount((C.itemCount || 0) + qty, true);
    if (CD && !d.stay) {
      // the drawer takes over from cl-product.js's trip to /cart (cart page stays the full cart)
      d.handled = true;
      // a second read 1.5 s later picks up lines an app adds in response (a BOGOS free gift)
      CD.refresh().then(function () { CD.open(null, d.form); setTimeout(CD.refresh, 1500); });
      var sc = d.form && d.form.closest ? (d.form.closest('[data-cl-product], .cl-product') || document) : document;
      sc.querySelectorAll('[data-cl-add], [data-cl-sticky-atc]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      return;
    }
    if (d.stay) return;
    try {
      sessionStorage.setItem('cl_cart_added', JSON.stringify({ title: it.product_title || it.title, at: Date.now() }));
    } catch (x) { /* storage off */ }
    var scope = d.form && d.form.closest ? (d.form.closest('[data-cl-product], .cl-product') || document) : document;
    scope.querySelectorAll('[data-cl-add-label], [data-cl-sticky-label]').forEach(function (l) { l.textContent = L.added || 'Added'; });
    scope.querySelectorAll('[data-cl-add], [data-cl-sticky-atc]').forEach(function (b) { b.classList.add('is-added'); });
  });

  var toastEl = null, toastTimer = null;
  function toast(item, error) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cl cl-ctoast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastTimer);
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    if (error) {
      toastEl.innerHTML = '<p class="cl-ctoast__text">' + esc(L.error) + '</p>' +
        '<button type="button" class="cl-ctoast__close" aria-label="' + esc(L.close || 'Close') + '">&times;</button>';
    } else {
      var img = item && (item.featured_image && item.featured_image.url || item.image);
      if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') < 0 ? '?' : '&') + 'width=160';
      toastEl.innerHTML =
        (img ? '<span class="cl-ctoast__img"><img src="' + esc(img) + '" alt="" width="64" height="64"></span>' : '') +
        '<div class="cl-ctoast__body"><p class="cl-ctoast__title"><svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="currentColor"/><path d="M6 10.4l2.6 2.6L14 7.6" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(L.addedTo || 'Added to your cart') + '</p>' +
        '<p class="cl-ctoast__text">' + esc(item && (item.product_title || item.title)) + '</p>' +
        '<div class="cl-ctoast__actions"><a class="button-secondary" href="' + esc(C.cartUrl || '/cart') + '">' + esc(L.viewCart || 'View cart') + '</a>' +
        '<a class="button" href="' + esc(root) + 'checkout" data-cl-toast-checkout>' + esc(L.checkout || 'Check out') + '</a></div></div>' +
        '<button type="button" class="cl-ctoast__close" aria-label="' + esc(L.close || 'Close') + '">&times;</button>';
    }
    toastEl.classList.add('is-on');
    toastTimer = setTimeout(hideToast, 7000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-on'); }

  /* Black Friday catalogue (sections/cl-catalogue, Gabriella 2026-10-15): a quick-add button with
     data-cl-code puts that discount code on the cart after the add. /cart/update.js `discount`
     replaces the cart's codes, so the codes already there are sent with it (BLACK30 for the sauna
     and BFVIP for the tower stack). A code Shopify rejects simply stays off; the add stands.
     2026-10-15 review: code updates run one after another (two quick adds read the same cart and
     the second dropped the first's code), and the cart page's code field adds to the codes too.
     Tower first, sauna second: Shopify drops BFVIP the moment it is added without a sauna (Craftly
     rule "40% RTL BFVIP Condition"), so a sauna's add also puts the tower code back on while the
     tower is in the cart (data-cl-tower-variant / data-cl-tower-code on the catalogue root). */
  var codeH = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var codeQueue = Promise.resolve();
  // { list: the cart's codes plus `codes`, comma-joined for /cart/update.js `discount`; added: false when all were on already }.
  // whenIn { variant, code }: that code too, but only while the cart holds that variant.
  function codesWith(codes, whenIn) {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: codeH }).then(function (r) { return r.json(); }).then(function (cart) {
      var have = (cart.discount_codes || []).map(function (d) { return d.code; });
      var want = codes.slice();
      if (whenIn && whenIn.code && (cart.items || []).some(function (i) { return String(i.variant_id) === String(whenIn.variant); })) want.push(whenIn.code);
      var added = false;
      want.forEach(function (code) {
        if (have.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) return;
        have.push(code);
        added = true;
      });
      return { list: have.join(','), added: added };
    });
  }
  function addCode(code, whenIn) {
    var run = codeQueue.then(function () {
      return codesWith([code], whenIn).then(function (c) {
        return c.added && fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: codeH, body: JSON.stringify({ discount: c.list }) });
      });
    });
    codeQueue = run.catch(function () {});
    return run;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (toastEl && toastEl.contains(t)) {
      if (t.closest('.cl-ctoast__close')) hideToast();
      return;
    }
    var b = t.closest('[data-cl-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    var label = b.textContent;
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-cl-quick-add')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    }).then(function (res) {
      var code = (b.getAttribute('data-cl-code') || '').trim();
      var tw = b.closest('[data-cl-tower-code]');
      var whenIn = tw && { variant: tw.getAttribute('data-cl-tower-variant'), code: tw.getAttribute('data-cl-tower-code') };
      return code ? addCode(code, whenIn).then(function () { return res; }, function () { return res; }) : res;
    }).then(function (res) {
      var it = res && res.items ? res.items[0] : res;
      document.dispatchEvent(new CustomEvent('cl:cart-added', { detail: { item: it, form: b, stay: true, quantity: 1, wait: null } }));
      b.textContent = L.added || 'Added';
      b.classList.add('is-added');
      if (CD) {
        var inDrawer = CD.el.contains(b);
        return CD.refresh().then(function () { if (!inDrawer) CD.open(null, b); else CD.say(L.addedTo || 'Added to your cart'); });
      }
      toast(it);
      return refreshCount(false);
    }).catch(function () {
      toast(null, true);
    }).then(function () {
      b.removeAttribute('aria-busy');
      setTimeout(function () { b.textContent = label; b.classList.remove('is-added'); }, 2500);
    });
  });

  /* ------------------------------------------------------------- cart drawer */
  /* sections/cl-cart-drawer.liquid (commerce only, never on /cart). A native <dialog> on the shared
     drawer shell (.cl-drawer, the contact / search / region drawers' classes, Gabriel 2026-10-10), so
     the motion is theirs too: assets/cl-topbar.js opens it (window.clOpenDrawer), slides it in from
     the right (a bottom sheet below 768, dragged down by the grip or the head), and closes it on Esc,
     the X, the dimmed page and the drag, waiting for the slide out before dialog.close(); html.cl-lock
     holds the page without a shift (scrollbar-gutter, cl-base.css). Here: focus is kept inside (Tab
     wraps) and returns to the opener on close. Without cl-topbar.js the same steps run from here.
     Contents come from the server: /cart/change.js and /cart/add.js answers carry the re-rendered
     section (`sections`), the header icon and pageshow re-read it with the Section Rendering API.
     Quantity changes post only line + quantity, never attributes, so _ph_distinct_id /
     _ph_session_id stay on the cart. Opening it dispatches cl:cart-viewed (PostHog Cart Viewed,
     location drawer); nothing goes to the dataLayer (the Google & YouTube app owns add_to_cart). */
  function drawer(dlg) {
    var SID = 'cl-cart-drawer';
    var opener = null, typing = null;
    var SLIDE = 320;   // --cl-drawer-slide in cl-topbar.css
    var status = dlg.querySelector('[data-cl-cd-status]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function inner() { return dlg.querySelector('[data-cl-cd-inner]'); }
    function say(t) { if (status) { status.textContent = ''; setTimeout(function () { status.textContent = t; }, 30); } }
    function swap(html) {
      if (!html) return false;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cl-cd-inner]');
      var cur = inner();
      if (!fresh || !cur) return false;
      // keep focus on the same control of the same line across the swap
      var a = document.activeElement, keep = null;
      if (a && dlg.contains(a)) {
        var li = a.closest('[data-cl-key]');
        // the key can change with the quantity (a discount re-hashes it), so the line number backs it up
        keep = { key: li && li.getAttribute('data-cl-key'), idx: li && li.getAttribute('data-cl-cd-line'), step: a.getAttribute('data-cl-cd-step'), qty: a.hasAttribute('data-cl-cd-qty'), close: a.hasAttribute('data-cl-cd-close') };
      }
      var top = (cur.querySelector('[data-cl-cd-scroll]') || {}).scrollTop || 0;
      cur.innerHTML = fresh.innerHTML;
      // the head stays put (the sheet drag is bound to it): only its count follows the cart
      var tNew = fresh.ownerDocument.querySelector('[data-cl-cd-title]'), tCur = dlg.querySelector('[data-cl-cd-title]');
      if (tNew && tCur) tCur.innerHTML = tNew.innerHTML;
      ['data-cl-cd-count', 'data-cl-cd-lines', 'data-cl-cd-total'].forEach(function (k) { cur.setAttribute(k, fresh.getAttribute(k) || '0'); });
      var sc = cur.querySelector('[data-cl-cd-scroll]');
      if (sc) sc.scrollTop = top;
      if (keep) {
        var t = null;
        var line = keep.key ? cur.querySelector('[data-cl-key="' + keep.key.replace(/"/g, '') + '"]') : null;
        if (!line && keep.idx) line = cur.querySelector('[data-cl-cd-line="' + keep.idx.replace(/"/g, '') + '"]');
        if (line && keep.step) t = line.querySelector('[data-cl-cd-step="' + keep.step + '"]');
        else if (line && keep.qty) t = line.querySelector('[data-cl-cd-qty]');
        if (keep.close || !t) t = dlg.querySelector('[data-cl-cd-close]');
        if (t) t.focus({ preventScroll: true });
      }
      setCount(Number(cur.getAttribute('data-cl-cd-count')) || 0, false);
      return true;
    }
    function refresh() {
      return fetch(root + '?sections=' + SID, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { swap(j && j[SID]); })
        .catch(function () { /* keep what is shown */ });
    }
    function focusables() {
      return Array.prototype.filter.call(dlg.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }
    function shared() { return !!window.clTopbarReady && typeof window.clOpenDrawer === 'function'; }
    function open(trigger, from) {
      opener = trigger || (from && from.querySelector && from.querySelector('[data-cl-add]')) || document.activeElement;
      if (dlg.open) return;
      if (shared()) {
        window.clOpenDrawer(dlg.id);
      } else {
        document.documentElement.classList.add('cl-lock');
        dlg.showModal();
        void dlg.offsetWidth;   // commit the closed transform so the panel slides
        dlg.classList.add('is-open');
        var x = dlg.querySelector('[data-cl-cd-close]');
        if (x) x.focus({ preventScroll: true });
      }
      if (!dlg.open) return;
      var i = inner();
      document.dispatchEvent(new CustomEvent('cl:cart-viewed', { detail: {
        location: 'drawer',
        value: i ? (Number(i.getAttribute('data-cl-cd-total')) || 0) / 100 : null,
        items_count: i ? Number(i.getAttribute('data-cl-cd-count')) || 0 : null,
        lines_count: i ? Number(i.getAttribute('data-cl-cd-lines')) || 0 : null
      } }));
    }
    // the fallback close, the same steps as cl-topbar.js's closeDrawer: slide out, then close()
    function close() {
      if (!dlg.open || dlg.clClosing) return;
      if (shared()) { var x = dlg.querySelector('[data-cl-drawer-close]'); if (x) { x.click(); return; } }
      var panel = dlg.querySelector('.cl-drawer__panel'), done = false;
      function finish() {
        if (done) return;
        done = true;
        if (panel) panel.removeEventListener('transitionend', onEnd);
        dlg.clClosing = false;
        dlg.close();
      }
      function onEnd(e) { if (e.target === panel && e.propertyName === 'transform') finish(); }
      dlg.clClosing = true;
      dlg.classList.remove('is-open');
      if (reduce || !panel) { finish(); return; }
      panel.addEventListener('transitionend', onEnd);
      setTimeout(finish, SLIDE + 80);
    }
    dlg.addEventListener('close', function () {
      dlg.classList.remove('is-open');
      if (!shared() && !document.querySelector('.cl-nav.is-menu-open')) document.documentElement.classList.remove('cl-lock');
      if (opener && opener.focus && document.contains(opener) && !dlg.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    });
    function post(path, body) {
      dlg.classList.add('is-busy');
      body.sections = SID;
      return fetch(root + path, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function (res) {
        if (!swap(res.sections && res.sections[SID])) return refresh();
        document.dispatchEvent(new CustomEvent('cl:cart-updated', { detail: res }));
        say(L.updated || 'Cart updated');
      }).catch(function (err) {
        var msg = (err && (err.description || err.message)) || L.error;
        var i = inner(), lines = i && i.querySelector('.cl-cd__lines');
        if (lines) {
          var old = i.querySelector('.cl-cd__error');
          if (old) old.remove();
          var p = document.createElement('p');
          p.className = 'cl-cd__error';
          p.setAttribute('role', 'alert');
          p.textContent = msg;
          lines.parentNode.insertBefore(p, lines);
        }
      }).then(function () { dlg.classList.remove('is-busy'); });
    }
    function change(line, qty) { return post('cart/change.js', { line: Number(line), quantity: Math.max(0, qty) }); }

    // Esc, the X and the dimmed page belong to cl-topbar.js when it is on the page
    dlg.addEventListener('cancel', function (e) { if (shared()) return; e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg || t.closest('[data-cl-cd-close]')) { if (!shared()) close(); return; }
      var line = t.closest('[data-cl-cd-line]');
      var step = t.closest('[data-cl-cd-step]');
      if (step && line) {
        var input = line.querySelector('[data-cl-cd-qty]');
        var next = Math.max(0, (Number(input.value) || 0) + Number(step.getAttribute('data-cl-cd-step')));
        input.value = next;
        clearTimeout(typing);
        change(line.getAttribute('data-cl-cd-line'), next);
        return;
      }
      if (t.closest('[data-cl-cd-remove]') && line) { e.preventDefault(); change(line.getAttribute('data-cl-cd-line'), 0); }
    });
    dlg.addEventListener('input', function (e) {
      var input = e.target.closest && e.target.closest('[data-cl-cd-qty]');
      if (!input) return;
      var line = input.closest('[data-cl-cd-line]');
      clearTimeout(typing);
      typing = setTimeout(function () { if (input.value !== '') change(line.getAttribute('data-cl-cd-line'), Number(input.value) || 0); }, 600);
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    return { el: dlg, open: open, close: close, refresh: refresh, say: say };
  }
  var cdEl = document.querySelector('[data-cl-cd]');
  var CD = cdEl && typeof cdEl.showModal === 'function' ? drawer(cdEl) : null;
  if (CD) {
    // the header cart icon opens the drawer; it stays a link to /cart without script. The click
    // still reaches GTM (icon-cart, Floodlight viewc0) before the default is prevented here.
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-cl-cart-link]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      CD.open(a);
      CD.refresh();
    });
  }

  /* --------------------------------------------------------------- cart page */
  var cartRoot = document.querySelector('[data-cl-cart]');
  if (!cartRoot) return;
  var sectionId = cartRoot.getAttribute('data-section-id');

  function showAdded() {
    var a = null;
    try { a = JSON.parse(sessionStorage.getItem('cl_cart_added') || 'null'); sessionStorage.removeItem('cl_cart_added'); } catch (x) { /* storage off */ }
    if (!a || !a.title || Date.now() - a.at > 5 * 60 * 1000) return;
    var box = cartRoot.querySelector('[data-cl-cart-added]');
    var txt = cartRoot.querySelector('[data-cl-cart-added-text]');
    if (!box || !txt) return;
    txt.textContent = a.title;
    box.hidden = false;
  }
  showAdded();

  /* Section Store upsell (app block, shadow DOM, live ANZ cart): our layout inside its shadow root
     (image | title + price | pill button, the button under the text below 480px, never over it) and
     no offer for a product already in the cart. Re-applied after every re-render and when the app
     redraws; after the app's own Add the section is re-rendered so the new line shows and the offer goes. */
  var UPSELL_CSS =
    '.upsell-box{flex-wrap:nowrap;justify-content:flex-start;gap:1rem;align-items:center}' +
    '.product-detail{width:auto;flex:1 1 auto;min-width:0}' +
    '.product-image-link{min-width:0;flex:none}' +
    '.product-image{width:4rem;height:4rem;min-width:0;min-height:0;max-width:none;object-fit:contain}' +
    '.product-text{min-width:0;padding:0 0 0 .875rem}' +
    '.product-title{font-family:"Sanomat",Georgia,serif;font-size:1.125rem;line-height:1.3;color:#251f20}' +
    '.product-subtitle{font-size:.9375rem;color:#251f20b3}' +
    '.add-to-cart{flex:none}' +
    '.add-to-cart button{width:auto;height:2.75rem;padding:0 1.25rem;border-radius:999px;background-color:#251f20;gap:.375rem}' +
    '.add-to-cart button:hover{opacity:1;background-color:#3a3233}' +
    '.add-to-cart button .icon{width:1rem;height:1rem;margin:0}' +
    '.add-to-cart button .text{font-family:"Adelle Sans",-apple-system,sans-serif;font-size:.8125rem;font-weight:500;letter-spacing:1px;text-transform:uppercase}' +
    '@container (max-width: 479px){.upsell-box{flex-wrap:wrap}.add-to-cart{flex:1 0 100%}.add-to-cart button{width:100%}}';
  function upsells() {
    var inCart = {};
    cartRoot.querySelectorAll('[data-cl-product-id]').forEach(function (l) { inCart[l.getAttribute('data-cl-product-id')] = true; });
    cartRoot.querySelectorAll('section-store--upsell-block').forEach(function (host) {
      var sr = host.shadowRoot;
      if (!sr) return;
      if (!sr.querySelector('style[data-cl]')) {
        var st = document.createElement('style');
        st.setAttribute('data-cl', '');
        st.textContent = UPSELL_CSS;
        sr.appendChild(st);
      }
      if (!host.__clObs && 'MutationObserver' in window) {
        host.__clObs = new MutationObserver(function () { upsells(); });
        host.__clObs.observe(sr, { childList: true, subtree: true });
      }
      // outside the shop currency the cart prints the code after the amount ($3,599.00 NZD); the app does not
      if (C.currency && C.shopCurrency && C.currency !== C.shopCurrency) {
        sr.querySelectorAll('.product-subtitle .price, .product-subtitle .original-price').forEach(function (el) {
          var tx = el.textContent.trim();
          if (tx && tx.indexOf(C.currency) < 0) el.textContent = tx + ' ' + C.currency;
        });
      }
      var boxes = sr.querySelectorAll('.upsell-box[data-product-id]');
      var shown = 0;
      boxes.forEach(function (b) {
        var hide = !!inCart[b.getAttribute('data-product-id')];
        if (hide) b.setAttribute('hidden', ''); else { b.removeAttribute('hidden'); shown++; }
        b.style.display = hide ? 'none' : '';
      });
      var wrap = host.closest('.cl-cartc__app');
      if (wrap) { wrap.hidden = boxes.length > 0 && shown === 0; if (boxes.length) wrap.classList.add('is-ready'); }
    });
  }
  upsells();
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('section-store--upsell-block').then(function () { setTimeout(upsells, 0); });
  var upsellTries = 0, upsellTimer = setInterval(function () { upsells(); if (++upsellTries > 20) clearInterval(upsellTimer); }, 500);
  function rerender() {
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var sections = {};
        sections[sectionId] = html;
        return getCart().then(function (c) { c.sections = sections; render(c); });
      }).catch(function () { window.location.reload(); });
  }

  function render(res) {
    var html = res && res.sections && res.sections[sectionId];
    if (!html) { window.location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cl-cart]');
    if (!fresh) { window.location.reload(); return; }
    var focusId = document.activeElement && document.activeElement.id;
    cartRoot.innerHTML = fresh.innerHTML;
    if (focusId) { var f = document.getElementById(focusId); if (f) f.focus(); }
    if (res.item_count != null) setCount(res.item_count, false);
    document.dispatchEvent(new CustomEvent('cl:cart-updated', { detail: res }));
    [0, 300, 1000, 2500].forEach(function (ms) { setTimeout(upsells, ms); });
  }
  function post(path, body) {
    cartRoot.classList.add('is-busy');
    body.sections = sectionId;
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (res) {
      render(res);
      return res;
    }).catch(function (err) {
      var msg = (err && (err.description || err.message)) || L.error;
      var line = cartRoot.querySelector('.cl-cartc__lines');
      if (line) {
        var p = document.createElement('p');
        p.className = 'cl-cartc__error';
        p.setAttribute('role', 'alert');
        p.textContent = msg;
        line.parentNode.insertBefore(p, line);
      }
    }).then(function (res) {
      cartRoot.classList.remove('is-busy');
      return res;
    });
  }
  function change(lineIndex, qty) {
    return post('cart/change.js', { line: Number(lineIndex), quantity: Math.max(0, qty) });
  }

  var typing = null;
  cartRoot.addEventListener('click', function (e) {
    var t = e.target;
    // the upsell app's Add (inside its shadow root; the event is retargeted to the host)
    var path = e.composedPath ? e.composedPath() : [];
    if (path.some(function (n) { return n.classList && n.classList.contains('add-to-cart'); }) && t.closest && t.closest('section-store--upsell-block')) {
      setTimeout(rerender, 1800);
      return;
    }
    var step = t.closest('[data-cl-qty-step]');
    var rem = t.closest('[data-cl-remove]');
    var apply = t.closest('[data-cl-discount-apply]');
    var line = t.closest('[data-cl-line]');
    if (step && line) {
      var input = line.querySelector('[data-cl-qty-input]');
      var next = (Number(input.value) || 0) + Number(step.getAttribute('data-cl-qty-step'));
      input.value = Math.max(0, next);
      clearTimeout(typing);
      change(line.getAttribute('data-cl-line'), Math.max(0, next));
    } else if (rem && line) {
      e.preventDefault();
      change(line.getAttribute('data-cl-line'), 0);
    } else if (apply) {
      var field = cartRoot.querySelector('[data-cl-discount-input]');
      var code = field ? field.value.trim() : '';
      if (!code) { if (field) field.focus(); return; }
      // next to the codes already on (the catalogue's BLACK30 + BFVIP), not in their place
      codeQueue = codeQueue.then(function () {
        return codesWith([code]).then(function (c) {
          return post('cart/update.js', { discount: c.list });
        }, function () { return post('cart/update.js', { discount: code }); });
      });
    }
  });
  cartRoot.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-cl-qty-input]');
    if (!input) return;
    var line = input.closest('[data-cl-line]');
    clearTimeout(typing);
    typing = setTimeout(function () {
      if (input.value === '') return;
      change(line.getAttribute('data-cl-line'), Number(input.value) || 0);
    }, 600);
  });
  cartRoot.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest && e.target.closest('[data-cl-discount-input]');
    if (field) { e.preventDefault(); var b = cartRoot.querySelector('[data-cl-discount-apply]'); if (b) b.click(); }
  });
  cartRoot.addEventListener('change', function (e) {
    var note = e.target.closest && e.target.closest('[data-cl-cart-note]');
    if (!note) return;
    fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () { /* posted with the form at checkout anyway */ });
  });
})();
